module.exports = __webpack_public_path__ + "static/media/Div-Wordpress.1207e54f.pdf";